import { api } from '@services/api';

type PostRefreshTokenReturn = {
  access: string;
  refresh: string;
};

type Me = {
  permissions: string[];
  area_leader: number[];
};

export async function postRefreshToken(data: {
  refresh: string;
}): Promise<PostRefreshTokenReturn> {
  const response = await api.post(
    'accounts/authentication/refresh-token/',
    data,
  );
  return response.data;
}

export async function authMe(): Promise<Me> {
  const response = await api.get('accounts/user/me/');
  return response.data;
}
